import React, { useEffect, useState } from "react";
import { Form, Input, Typography, Row, Col, Spin, message, Checkbox, Card, Divider } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import ApplicationHeader from "../../../components/ApplicationHeader";
import LoanApplicationFooter from "../../../components/LoanApplicationFooter";
import LoanApplicationStepper from "../../../components/LoanApplicationStepper";
import moment from "moment";
import { routes } from "../../../routes/Routes";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import _consumerService from "../../../modules/consumerService";
import CurrencyInput from "../../../components/CurrencyInput";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import "./NewLiquidityApplication.css";

const { Text, Title } = Typography;

const NewLiquidityApplication = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const consumerId = localStorage.getItem("ConsumerUserId");
    const [form] = Form.useForm();
    const location = useLocation();
    let locData = location.state;
     let applnObjId = "";
    let activeKeyTab = null;
    let fromNewApplicationPage = false;
    let isFromBackUploadBtn = false;
    let fromDashboard = false;
    let isEditApplicationFromDetailPage = false;

    if (locData && locData.isEditApplicationFromDetailPage) {
        isEditApplicationFromDetailPage = locData.isEditApplicationFromDetailPage;
    }   
if (locData && locData.applicationObjId) {
        applnObjId = locData.applicationObjId;
    }
    if (locData && locData.activeKey) {
        activeKeyTab = locData.activeKey;
    }
     if (locData && locData.isFromDashboard) {
        fromDashboard = locData.isFromDashboard;
    }
    if (locData && locData.fromNewApplicationPage) {
        fromNewApplicationPage = locData.fromNewApplicationPage
    }

    if (locData && locData.isFromBackUploadBtn) {
        isFromBackUploadBtn = locData.isFromBackUploadBtn;
    }
     const [tabActiveKey] = useState(activeKeyTab);
    const [appObjId] = useState(applnObjId);
    const [isFromBackUploadButton] = useState(isFromBackUploadBtn);
    const [fromNewAppPage] = useState(JSON.parse(localStorage.getItem("fromNewApplicationPage")) || fromNewApplicationPage);
    const [consumerFromProfileID] = useState(locData?.consumerId);
    const [isFromMyAppListPage] = useState(JSON.parse(localStorage.getItem("isFromMyApplicationsList")));
    const [personalInfo, setPersonalInfo] = useState({});
    const [showPersonal, setShowPersonal] = useState(false);

    useEffect(() => form.resetFields(), [personalInfo]);

    useEffect(() => {
        setShowPersonal(form.getFieldValue("confirmIdDetails"));
    }, [form.getFieldValue("confirmIdDetails")]);

    useEffect(() => {
        if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
            history.push({ pathname: routes.consumerDashboard.path });
            return;
        }

        getpersonalDetailsById();
    }, []);

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const reqObj = {
                Id: fromNewAppPage && !isFromBackUploadButton ? 0 : consumerFromProfileID ? consumerFromProfileID : consumerId,
                ScreenName: fromNewAppPage && !isFromBackUploadButton ? "newliquidityapp" : "updateliquidityapp",
                Cons_UseofProceeds: values.useOfProceeds,
                Cons_ApproximateLoanSize: values.approximateLoanSize || null,
                Cons_ConfirmResidency: values.confirmResidency,
                Cons_ConfirmIDDetails: values.confirmIdDetails || false,
                Email: localStorage.getItem("consumerLoginEmail"),
                IsAapplicationDetailsCompleted: true,
            };

            const res = await _consumerService.updateConsumerData(reqObj);

            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                localStorage.setItem("ConsumerUserId", res?.data?.Obj?.Id);
                localStorage.setItem("ApplicationObjId", res?.data?.Obj?.Id)
                localStorage.setItem("ApplicationIdText", res?.data?.Obj?.ApplicationId);
                localStorage.setItem("ApplicationStatusId", res?.data?.Obj?.Application_Status_Id);
                if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
                    history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
                } else if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
                    history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
                } else if (fromNewAppPage || isFromMyAppListPage || isEditApplicationFromDetailPage) {
                    history.push({ pathname: routes.documentsUpload.path, state: { isFromDashboard: false } });
                } else {
                    history.push(routes.consumerDetailsDashboard.path);
                }
                setLoading(false);
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const getpersonalDetailsById = async () => {
        setLoading(true);
        try {
            const resObj = await _consumerService.getConsumerInformationByConsumerId(
                consumerFromProfileID ? consumerFromProfileID : consumerId
            );
            if (resObj.data) {
                const res = resObj.data;

                if (fromNewAppPage && !isFromBackUploadButton) {
                    setPersonalInfo({
                        applicationType: res.App_Det_Application_Type,
                        firstName: res.App_Det_FirstName,
                        middleInitial: res.App_Det_MiddleInitial,
                        lastName: res.App_Det_LastName,
                        dob: res.App_Det_DateOfBirth ? moment(res.App_Det_DateOfBirth) : null,
                        contactNumber: res.App_Det_ContactNumber,
                        email: res.Email,
                        city: res.Ident_City,
                        state: res.Ident_State,
                        zipCode: res.Ident_ZipCode,
                        employerName: res.Prof_Employer_Name,
                        employerPositionTitle: res.Prof_JobRole,
                        numberOfYearsWithEmployer: res.Prof_NO_Years,
                        Application_Status_Id: res.Application_Status_Id
                    });
                } else {
                    setPersonalInfo({
                        useOfProceeds: res?.Cons_UseofProceeds,
                        approximateLoanSize: res?.Cons_ApproximateLoanSize,
                        confirmResidency: res?.Cons_ConfirmResidency,
                        confirmIdDetails: res?.Cons_ConfirmIDDetails,

                        applicationType: res.App_Det_Application_Type,
                        firstName: res.App_Det_FirstName,
                        middleInitial: res.App_Det_MiddleInitial,
                        lastName: res.App_Det_LastName,
                        dob: res.App_Det_DateOfBirth ? moment(res.App_Det_DateOfBirth) : null,
                        contactNumber: res.App_Det_ContactNumber,
                        email: res.Email,
                        city: res.Ident_City,
                        state: res.Ident_State,
                        zipCode: res.Ident_ZipCode,
                        employerName: res.Prof_Employer_Name,
                        employerPositionTitle: res.Prof_JobRole,
                        numberOfYearsWithEmployer: res.Prof_NO_Years,
                        Application_Status_Id: res.Application_Status_Id
                    });
                }
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    };

    const onBack = () => {
        if (localStorage.getItem("IsFromApplicationStatusTab") === "true") {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "1" } });
        } else if (localStorage.getItem("IsFromConsumerDashboard") == "true") {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "3" } });
        }
         else if (fromDashboard) {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } 
        else if (fromNewAppPage || isFromMyAppListPage) {
            history.push(routes.consumerDashboard.path);
        }       
        else {
            history.push(routes.consumerDetailsDashboard.path);
        }
    };

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>

                <LoanApplicationStepper
                    currentStep={0}
                    showProgress={fromNewAppPage && !isFromBackUploadButton}
                    progressPercent={0}
                    showApplicationId={!(fromNewAppPage && !isFromBackUploadButton)}
                />
                <div className="loan-application-container" >
                    {/* Responsive Stepper */}


                    {/* Card */}
                    <Card
                        className="loan-application-card"
                        bodyStyle={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            overflow: "hidden",
                            padding: "24px",
                            borderRadius: "12px",
                        }}
                    >

                        {/* Application Header */}
                        {/* <ApplicationHeader
                            currentStep={1}
                            stepTitle="New Liquidity Application"
                            showProgress={fromNewAppPage && !isFromBackUploadButton}
                            progressPercent={0}
                            showApplicationId={!(fromNewAppPage && !isFromBackUploadButton)}
                        />

                        <Divider className="liquidity-divider" /> */}
                        <div className="loan-inner-wrapper">

                            <div className="loan-application-title-wrapper">
                               <Title level={1}>New Liquidity Application</Title>
                            </div>

                            <Form
                                form={form}
                                layout="vertical"
                                requiredMark={true}
                                onFinish={onFinish}
                                initialValues={personalInfo}
                                className="inputBoxStyle"
                            >
                                {/* Scrollable Form Content */}
                                <div >
                                    {/* Form Fields */}
                                    <Row gutter={[24, 0]} >
                                        <Col xs={24} md={24}>
                                            {/* <Form.Item
                                            label="Use of Proceeds"
                                            name="useOfProceeds"
                                            rules={[
                                                { required: true, message: "Use of Proceeds is required" },
                                                { pattern: /^[A-Za-z\s]+$/, message: "Only alphabets are allowed" }
                                            ]}
                                        >
                                            <Input placeholder="Enter Use of Proceeds" maxLength={50} size="large" />
                                        </Form.Item> */}

                                            <Form.Item
                                                label="Use of Proceeds"
                                                name="useOfProceeds"
                                                rules={[
                                                    { required: true, message: "Use of Proceeds is required" },
                                                    { pattern: /^[A-Za-z\s]+$/, message: "Only alphabets are allowed" }
                                                ]}
                                            >
                                                <Input.TextArea
                                                    placeholder="Short-term capital needs, investment in illiquid assets, etc."
                                                    autoSize={{ minRows: 3, maxRows: 4 }}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={24}>
                                            <Form.Item
                                                label="Requested Loan Amount"
                                                name="approximateLoanSize"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Requested Loan Amount is required"
                                                    },
                                                ]}
                                            >
                                                <CurrencyInput placeholder="Enter amount (e.g., 500,000)" size="large" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={24}>
                                            <Form.Item
                                                label="Residency / Jurisdiction"
                                                name="confirmResidency"
                                                rules={[{ required: true, message: "Residency / Jurisdiction is required" }]}
                                            >
                                                <Input placeholder="e.g., United States, Delaware, Cayman Islands" maxLength={50} size="large" />
                                            </Form.Item>
                                        </Col>

                                        {/* <Col xs={24} md={24}>
                                            <Form.Item
                                                label=" "
                                                name="confirmIdDetails"
                                                valuePropName="checked"
                                            >
                                                <Checkbox onChange={(e) => setShowPersonal(e.target.checked)}>Confirm ID Details</Checkbox>
                                            </Form.Item>
                                        </Col> */}
                                        <Col span={24} className="checkbox-row">
                                            <Form.Item name="confirmIdDetails" valuePropName="checked">
                                                <Checkbox onChange={(e) => setShowPersonal(e.target.checked)}>
                                                    Confirm ID Details
                                                </Checkbox>
                                            </Form.Item>
                                        </Col>

                                    </Row>

                                    {/* <Row gutter={[24, 24]} className="form-row-margin">
                                    <Col xs={24} md={24}>
                                        <Form.Item
                                            label="Residency / Jurisdiction"
                                            name="confirmResidency"
                                            rules={[{ required: true, message: "Residency / Jurisdiction is required" }]}
                                        >
                                            <Input placeholder="Enter Residency / Jurisdiction" maxLength={50} size="large" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Form.Item
                                            label=" "
                                            name="confirmIdDetails"
                                            valuePropName="checked"
                                        >
                                            <Checkbox onChange={(e) => setShowPersonal(e.target.checked)}>Confirm ID Details</Checkbox>
                                        </Form.Item>
                                    </Col>
                                </Row> */}

                                    {/* Personal Details Card */}
                                    {showPersonal && (
                                        <Card
                                            className="personal-details-card"
                                            title={
                                                <Text className="personal-details-title">

                                                    Personal Details
                                                </Text>
                                            }
                                        >
                                            <Row gutter={[64, 24]}>
                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">First Name:</Text>
                                                    <br />
                                                    <Text >{personalInfo.firstName || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Middle Initial:</Text>
                                                    <br />
                                                    <Text >{personalInfo.middleInitial || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Last Name:</Text>
                                                    <br />
                                                    <Text >{personalInfo.lastName || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Application Type:</Text>
                                                    <br />
                                                    <Text >{personalInfo.applicationType || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Date Of Birth:</Text>
                                                    <br />
                                                    <Text >
                                                        {personalInfo.dob ? moment(personalInfo.dob).format("MM/DD/YYYY") : "N/A"}
                                                    </Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Contact Number:</Text>
                                                    <br />
                                                    <Text >
                                                        {personalInfo.contactNumber ? `(${personalInfo.contactNumber.slice(0, 3)}) ${personalInfo.contactNumber.slice(3, 6)}-${personalInfo.contactNumber.slice(6)}` : "N/A"}
                                                    </Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Email:</Text>
                                                    <br />
                                                    <Text >{personalInfo.email || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">City:</Text>
                                                    <br />
                                                    <Text >{personalInfo.city || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">State:</Text>
                                                    <br />
                                                    <Text >{personalInfo.state || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Zip Code:</Text>
                                                    <br />
                                                    <Text >{personalInfo.zipCode || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Employer Name:</Text>
                                                    <br />
                                                    <Text >{personalInfo.employerName || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Position/Title:</Text>
                                                    <br />
                                                    <Text >{personalInfo.employerPositionTitle || "N/A"}</Text>
                                                </Col>

                                                <Col xs={24} sm={12} md={12}>
                                                    <Text type="secondary" className="personal-details-label">Number of Years with Employer:</Text>
                                                    <br />
                                                    <Text >{personalInfo.numberOfYearsWithEmployer || "N/A"}</Text>
                                                </Col>
                                            </Row>
                                        </Card>
                                    )}

                                </div>

                                <LoanApplicationFooter
                                    onBack={onBack}
                                    submitDisabled={fromNewAppPage ? false : ![1, 6].includes(Number(localStorage.getItem("ApplicationStatusId")))}
                                />
                            </Form>
                        </div>
                    </Card>
                </div>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default NewLiquidityApplication;